export default "__VITE_ASSET__6f51b2ec__"